import useActiveWorkspace from "./useActiveWorkspace";

import { useOrganization } from "@/queries/organizations";
import { useCurrentUser } from "@/queries/users";
import { useWorkspaces } from "@/queries";

const useActiveOrganization = () => {
  const activeWorkspace = useActiveWorkspace();
  const organization = useOrganization(activeWorkspace?.organization_id ?? 0);
  return { data: organization.data, isLoading: organization.isLoading };
};

const useIsOrgOwner = () => {
  const { data: activeOrg } = useActiveOrganization();
  const currentUser = useCurrentUser();

  return (
    currentUser.data?.memberships.organizations.find(org => org.organization_id === activeOrg?.id)
      ?.is_owner || false
  );
};

const useIsOrgOwnerById = (organizationId: number) => {
  const currentUser = useCurrentUser();

  return (
    currentUser.data?.memberships.organizations.find(org => org.organization_id === organizationId)
      ?.is_owner || false
  );
};

const useActiveOrgWorkspaces = () => {
  const workspaces = useWorkspaces();
  const { data: activeOrg } = useActiveOrganization();
  return (
    workspaces.data?.workspaces.filter(workspace => workspace.organization_id === activeOrg?.id) ||
    []
  );
};

export { useActiveOrganization, useActiveOrgWorkspaces, useIsOrgOwner, useIsOrgOwnerById };
